<template>
  <div>
    <div v-for="(component, index) in response" :key="index">
      <component
        :fields="component.fields"
        :type="component.type"
        :is="mappedComponent(component)"
      />
    </div>
  </div>
</template>

<script>
import { Teaser, MultiTeaser } from '@freddiesflowers/frontend-component-library';
import List from './List';
import PostcodeChecker from './PostcodeChecker';
import DynamicButton from './DynamicButton';

export default {
    name: 'trt-page-builder',
    data() {
        return {
            pageComponents: [
                {
                    type: 'teaser',
                    component: Teaser,
                },
                {
                    type: 'multi_teaser',
                    component: MultiTeaser,
                },
                {
                    type: 'check_postcode_area',
                    component: PostcodeChecker,
                },
                {
                    type: 'list',
                    component: List,
                },
                {
                    type: 'dynamic_button',
                    component: DynamicButton,
                },
            ],
        };
    },
    methods: {
        mappedComponent(component) {
            const componentObject = this.pageComponents.find(element => element.type === component.type);
            const vueComponent = componentObject && componentObject.component;
            return vueComponent || null;
        },
    },
    props: {
        response: {
            type: Array,
        },
    },
};
</script>
